<template>
  <b-container fluid class="curriculo-page p-0">
    <meu-menu> </meu-menu>

    <b-row>
      <b-col cols="12">
        <div>
          <form-wizard
            ref="form"
            nextButtonText="Próxima Etapa"
            backButtonText="Etapa Anterior"
            finishButtonText="Concluir e Salvar"
            shape="tab"
            color="#5e9cea"
            @on-complete="cadastrar"
          >
            <!-- Tab Dados Pessoais -->
            <tab-content
              title="Dados pessoais"
              :before-change="() => validateTab('dadosPessoais')"
            >
              <dados-pessoais ref="dadosPessoais"></dados-pessoais>
            </tab-content>
            <!-- Tab Dados Pessoais -->

            <!-- Tab Xp Profissional -->
            <tab-content
              title="Exp. Profissional"
              :before-change="() => validateTab('dadosExperiencia')"
            >
              <dados-experiencia ref="dadosExperiencia"></dados-experiencia>
            </tab-content>
            <!-- Tab Xp Profissional -->

            <!-- Tab Formações -->
            <tab-content
              title="Formações"
              :before-change="() => validateTab('dadosFormacao')"
            >
              <dados-formacao ref="dadosFormacao"></dados-formacao>
            </tab-content>
            <!-- Tab Formações -->

            <!-- Tab Curriculo -->
            <tab-content title="Currículo (PDF)">
              <dados-curriculo-anexo
                :before-change="() => validateTab('dadosCurriculoAnexo')"
                ref="dadosCurriculoAnexo"
              ></dados-curriculo-anexo>
            </tab-content>
            <!-- Tab Curriculo -->
            <template
              slot="footer"
              slot-scope="props"
              style="position: realative"
            >
              <div
                style="position: absolute; width: 100vw; z-index: 1"
                class="
                  d-flex
                  flex-row
                  justify-content-center
                  align-items-center
                  flex-sm-col
                "
                v-if="props.isLastStep"
              >
                <button v-b-modal.modal-lgpd class="btnTermos mr-4">
                  Ler os Termos
                </button>

                <b-form-checkbox
                  id="checkbox-1"
                  v-model="lgpd"
                  name="checkbox-1"
                  value="Aceito"
                  v-validate="{ required: true }"
                  unchecked-value="Não Aceito"
                >
                  <span class="d-none d-md-block">
                    Estou de acordo com os termos
                  </span>
                  <span class="d-md-none"> aceito os termos </span>
                </b-form-checkbox>
              </div>

              <div class="wizard-footer-left" v-if="!props.isLastStep">
                <wizard-button
                  v-if="props.activeTabIndex > 0 && !props.isLastStep"
                  @click.native="props.prevTab()"
                  :style="props.fillButtonStyle"
                  style="position: relative; z-index: 3"
                  v-bind:class="{ 'btn-sm-margin': props.isLastStep }"
                >
                  Voltar
                </wizard-button>
              </div>

              <div class="wizard-footer-left" v-if="props.isLastStep">
                <wizard-button
                  v-if="props.activeTabIndex > 0"
                  @click.native="props.prevTab()"
                  :style="props.fillButtonStyle"
                  style="position: relative; z-index: 3"
                  v-bind:class="{ 'btn-sm-margin': props.isLastStep }"
                >
                  Voltar
                </wizard-button>
              </div>
              <div class="wizard-footer-right">
                <wizard-button
                  v-if="!props.isLastStep"
                  @click.native="props.nextTab()"
                  v-bind:class="{ 'btn-sm-margin': props.isLastStep }"
                  class="wizard-footer-right"
                  :style="props.fillButtonStyle"
                  style="position: relative; z-index: 3"
                >
                  Próxima
                </wizard-button>

                <wizard-button
                  v-else
                  v-bind:class="{ 'btn-sm-margin': props.isLastStep }"
                  class="wizard-footer-right finish-button"
                  @click.native="cadastrar()"
                  :style="props.fillButtonStyle"
                  style="position: relative; z-index: 3"
                >
                  {{ props.isLastStep ? "Finalizar" : "Próximo" }}
                </wizard-button>
              </div>
            </template>
          </form-wizard>
        </div>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
/* eslint-disable no-console */
// eslint-disable-next-line no-unused-vars
import { sharedService } from "../../services";
import Menu from "../shared/Menu";
import Curriculo_Pessoais from "./Curriculo_Pessoais";
import Curriculo_Anexo from "./Curriculo_Anexo";
import Curriculo_Experiencia from "./Curriculo_Experiencia";
import Curriculo_Formacao from "./Curriculo_Formacao";

export default {
  name: "Painel",
  components: {
    "meu-menu": Menu,
    "dados-pessoais": Curriculo_Pessoais,
    "dados-curriculo-anexo": Curriculo_Anexo,
    "dados-experiencia": Curriculo_Experiencia,
    "dados-formacao": Curriculo_Formacao,
  },
  data() {
    return {
      status: false,
      lgpd: false,
    };
  },
  computed: {},
  created() {},
  methods: {
    cadastrar() {
      if (this.lgpd == false || this.lgpd == "Não Aceito") {
        this.$swal({
          icon: "error",
          position: "top",
          title: "Erro de Termos LGPD",
          html: "Aceite os termos LGPD para continuar",
        });
      } else {
        let self = this;
        let key = this.$store.getters.getApiKey || null;

        this.$store.dispatch("storeUser", null).then(function (obj) {
          obj.text().then(function (text) {
            if (obj.status === 200) {
              self
                .$swal({
                  icon: "success",
                  position: "top",
                  title: "Cadastro Efetuado",
                  html: "<p>Seu Curriculo esta salvo em nossa base de dados</b>, logo entraremos em contato com oportunidades de emprego</p> Enquanto isso, verifique em nossas vagas e encaminhe seu currículo para aquelas que se adequam ao seu perfil",
                  footer: "Dados salvos com sucesso",
                })
                .then(function () {
                  if (JSON.parse(text).token != null) {
                    self.$store.dispatch("setSair");
                    self.$router.push({
                      name: "curriculo_main",
                    });

                    if (self.$gAuth.isAuthorized == true) {
                      self.logOutGoogle();
                    }
                  } else {
                    self.$store.dispatch("setarUsuario", {
                      usuario: JSON.parse(text).usuario,
                      token: JSON.parse(text).token,
                    });

                    self.$router.push({
                      name: "vagas_ultimas",
                      query: {
                        api_key: key,
                      },
                    });
                  }
                });
            } else {
              self.$swal({
                icon: "error",
                position: "top",
                title: "Erro ao salvar seu cadastro",
                html: "Não foi possivel salvar seu curriculo no momento, por favor tente em alguns minutos! ",
                footer: text,
              });
            }
          });
        });
      }
    },
    validateTab(ref) {
      let self = this;
      // ? true = continua ? false = segura
      let status = false;

      self.$refs[ref].user.experiencia_lines.forEach(function (e) {
        // * Força validação e tipagem máquinas do formulário
        if (e.experiencia_maquinas == "Sim" || e.experiencia_maquinas == "1") {
          e.experiencia_maquinas = "1";
        } else {
          e.experiencia_maquinas = "0";
          e.maquinas = "";
        }

        // * Força validação e tipagem sistemas do formulário
        if (e.experiencia_sistemas == "Sim" || e.experiencia_sistemas == "1") {
          e.experiencia_sistemas = "1";
        } else {
          e.experiencia_sistemas = "0";
          e.sistemas = "";
        }
      });

      if (this.$refs[ref].is_edit == null) {
        this.$refs[ref].$validate().then(function (success) {
          if (!success) {
            self.$swal({
              icon: "error",
              position: "top",
              title: "Não é possivel proseguir",
              html: "Antes de prosseguir verifique todos os campos obrigatórios",
              footer: "Preencha e valide todos os campos obrigatórios",
            });

            return status;
          }
        });

        return this.$refs[ref].$validate();
      }

      if (self.$refs[ref].is_edit) {
        self.$swal({
          icon: "error",
          position: "top",
          title: "Não é possivel proseguir",
          html: "Antes de prosseguir clique no botão [Salvar] ou [Cancelar]",
          footer: "Preencha e valide todos os campos obrigatórios",
        });

        return status;
      }

      if (this.$refs[ref].user.experiencia_lines.length == 0) {
        if (
          this.$refs[ref].user.primeiro_emprego == "Sim" ||
          this.$refs[ref].user.primeiro_emprego == "1"
        ) {
          status = true;
          this.$refs[ref].user.primeiro_emprego = "1";
        } else {
          self.$swal({
            icon: "error",
            position: "top",
            title: "Não é possivel proseguir",
            html: "Antes de prosseguir cadastre uma nova experiência ou marque como primeiro emprego",
            // footer: "Preencha e valide todos os campos obrigatórios",
          });

          return status;
        }
      } else {
        status = true;
        this.$refs[ref].user.primeiro_emprego = "1";
      }

      return status;
    },
  },
  beforeMount() {},
  watch: {},
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style>
.espaco {
  margin-top: 30px;
}

.btnTermos {
  background: #f44336;
  display: inline-block;
  font-weight: 400;
  color: #fff;
  text-align: center;
  vertical-align: middle;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  border: 1px solid transparent;
  padding: 0.375rem 0.75rem;
  font-size: 1rem;
  line-height: 1.5;
  border-radius: 0.25rem;
}

.wizard-header {
  display: none;
}

.card-main {
  height: 65vh;
  overflow-y: auto;
}

.vue-form-wizard .wizard-card-footer {
  margin-bottom: 20px;
  margin-top: 0.4rem;
}

.container-fluid {
  overflow-y: hidden;
  overflow-x: hidden;
}

@media only screen and (max-width: 576px) {
  .card-main {
    height: auto;
  }

  .vue-form-wizard .wizard-card-footer {
    margin-top: 6%;
  }

  .container-fluid {
    overflow-y: auto;
  }

  .vue-form-wizard .wizard-nav-pills {
    display: none;
  }

  .vue-form-wizard .wizard-progress-bar {
    background-color: #17a2b8 !important;
    color: #17a2b8 !important;
    display: none;
  }
}

.vue-form-wizard
  .wizard-navigation
  .wizard-progress-with-circle
  .wizard-progress-bar {
  display: none;
}

.vue-form-wizard .wizard-nav-pills {
  margin-top: 10px;
  margin-left: 20px;
  margin-right: 20px;
}

/* Estilo das abas de progresso superior */
.vue-form-wizard .wizard-icon-circle.tab_shape {
  border: none;
  border-radius: 4px;
  height: 69px !important;
  box-shadow: rgb(0 0 0 / 16%) 5px 8px 14px;
  background: rgb(255, 255, 255);
  width: 60%;
  margin-top: 5vh;
}

.stepTitle {
  margin-top: 9%;
  margin-bottom: -25px;
  font-weight: bold;
}

.stepTitle .active {
  color: #fff !important;
}

@media only screen and (max-width: 576px) {
  .btn-sm-margin {
    margin-top: 9.5ch !important;
  }
  .flex-sm-col {
    flex-direction: column !important;
    justify-content: center;
    align-items: center;
  }
  .btnTermos {
    margin-bottom: 0.8ch;
  }
}
.curriculo-page {
  height: 100vh;
  overflow: hidden;
}

@media only screen and (max-width: 576px) {
  .curriculo-page {
    height: auto;
    overflow-x: hidden;
    overflow-y: auto;
  }
}
</style>
